<script setup lang="ts">
interface Props {
  color: string
  direction: string
}

defineProps<Props>()
</script>

<template>
  <div
    class="text-2xl font-bold"
    :class="[`text-${color}`, `text-${direction}`]"
  >
    <slot></slot>
  </div>
</template>
